import { Injectable } from '@angular/core';

declare global {
    interface Window {
        __env: any;
    }
}

@Injectable({
    providedIn: 'root'
})
export class RuntimeConfigService {

    get BasePath(): string {
        return window.__env?.BasePath || '';
    }

    get APIUrl(): string {
        return window.__env?.APIUrl || '';
    }
}
